/*
 * 企業側 案件詳細（ファイル共有の更新）
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_GET_ONE_CLIENT_RFP_SHARE_DOCUMENT_MESSAGE = 'API_GET_ONE_CLIENT_RFP_SHARE_DOCUMENT_MESSAGE';
/**
 * クライアント：ファイル共有 メッセージ送信
 */
export const apiGetOneClientRfpShareDocumentMessage = ({ json, path: { id, viewRequestId } }, meta) => apiUpdate(API_GET_ONE_CLIENT_RFP_SHARE_DOCUMENT_MESSAGE, `/client/rfp/${id}/share_document_message/${viewRequestId}/message`, json, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { id } }));
